import React, { useState, useRef, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getGeolocalizacion } from "../../../utils/variablesLocales";

import { MapContainer, TileLayer, useMap, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Marker as LeafletMarker, icon } from "leaflet";
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";
import * as L from "leaflet";
import "leaflet-routing-machine";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import { Alert } from "@mui/material";

import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import PlaceIcon from "@mui/icons-material/Place";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import TripOriginIcon from "@mui/icons-material/TripOrigin";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import CloseIcon from "@mui/icons-material/Close";
import CancelIcon from "@mui/icons-material/Cancel";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Form, Segment, Divider, Input, List } from "semantic-ui-react";
import Autocomplete from "@mui/material/Autocomplete";

import { ENTORNO } from "../../../utils/constantes";
import {
  calcular_trayecto,
  cancelar,
  nuevo_viaje,
  si,
  vas_a_confirmar_el_viaje,
  viaje_registrado_con_exito,
  tienes_un_viaje_en_curso,
  en_cuanto_finalice_el_mismo_podras_solicitar_uno_nuevo,
  resumen_del_viaje,
  destino,
  partida,
  trayecto,
  resumen,
  confirmar,
  metodo_de_pago,
  falta_agregar_metodo_de_pago_valido,
  pago,
  selecciona_punto_de_partida,
  selecciona_punto_destino,
  para_continuar_debes_activar_el_gps,
  punto_de_partida,
  punto_destino,
  buscar_calle,
  tu_ubicacion,
} from "../../../utils/traductor";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import animacion from "../../../imagenes/AnimacionesVarias/LoadingMap.json";
import { Player } from "@lottiefiles/react-lottie-player";

import Swal from "sweetalert2";

import { apiGeolocalizacion } from "../../../api/geolocalizacion";

const apigeolocalizacion = new apiGeolocalizacion();

export function NuevoViaje1(props) {
  const [PartidaLatitud, setPartidaLatitud] = useState("");
  const [PartidaLongitud, setPartidaLongitud] = useState("");
  const [PartidaDireccion, setPartidaDireccion] = useState("");

  const [DestinoLatitud, setDestinoLatitud] = useState("");
  const [DestinoLongitud, setDestinoLongitud] = useState("");
  const [DestinoDireccion, setDestinoDireccion] = useState("");

  const [Kms, setKms] = useState("");
  const [Min, setMin] = useState("");
  const [Precio, setPrecio] = useState("");

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const navigate = useNavigate();

  const position = [
    getGeolocalizacion().split("|")[3],
    getGeolocalizacion().split("|")[4],
  ];

  ////////////////////////////////////////////////////////

  const navigateToInicio = async () => {
    navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
  };

  ////////////////////////////////////////////////////////

  const calcularLatLonGPS = async (PartidaDestino) => {
    try {
      //calculo lat lon con GPS
      const onUbicacionConcedida = (ubicacion) => {
        if (PartidaDestino === "Partida") {
          setPartidaLatitud(ubicacion.coords.latitude);
          setPartidaLongitud(ubicacion.coords.longitude);
        } else {
          setDestinoLatitud(ubicacion.coords.latitude);
          setDestinoLongitud(ubicacion.coords.longitude);
        }

        calcularReverse(
          ubicacion.coords.latitude,
          ubicacion.coords.longitude,
          PartidaDestino
        );
      };

      const onErrorDeUbicacion = (err) => {
        if (PartidaDestino === "Partida") {
          setPartidaLatitud("");
          setPartidaLongitud("");
          setPartidaDireccion("");
        } else {
          setDestinoLatitud("");
          setDestinoLongitud("");
          setDestinoDireccion("");
        }

        Swal.fire({
          // type: "success",
          title: para_continuar_debes_activar_el_gps,
          text: "",
          timer: 1500,
          showCancelButton: false,
          showConfirmButton: false,
        });
      };

      const opcionesDeSolicitud = {
        enableHighAccuracy: true, // Alta precisión
        maximumAge: 0, // No queremos caché
        timeout: 5000, // Esperar solo 5 segundos
      };

      // Solicitar
      navigator.geolocation.getCurrentPosition(
        onUbicacionConcedida,
        onErrorDeUbicacion,
        opcionesDeSolicitud
      );
    } catch (error) {
      console.error(error);
    }
  };

  ////////////////////////////////////////////////////////
  //calcular reverse
  const calcularReverse = async (Lat, Lon, PartidaDestino) => {
    try {
      const resultado = await apigeolocalizacion.LatLonToDireccionPostal(
        Lat,
        Lon
      );

      if (PartidaDestino === "Partida") {
        setPartidaDireccion(resultado.Direccion);
      } else {
        setDestinoDireccion(resultado.Direccion);
      }
    } catch (error) {
      console.error(error);
    }
  };

  ////////////////////////////////////////////////////////

  const girarPartidaDestino = async () => {
    try {
      const PartidaLatitudAux = PartidaLatitud;
      const PartidaLongitudAux = PartidaLongitud;
      const PartidaDireccionAux = PartidaDireccion;

      const DestinoLatitudAux = DestinoLatitud;
      const DestinoLongitudAux = DestinoLongitud;
      const DestinoDireccionAux = DestinoDireccion;

      setPartidaLatitud(DestinoLatitudAux);
      setPartidaLongitud(DestinoLongitudAux);
      setPartidaDireccion(DestinoDireccionAux);

      setDestinoLatitud(PartidaLatitudAux);
      setDestinoLongitud(PartidaLongitudAux);
      setDestinoDireccion(PartidaDireccionAux);
    } catch (error) {
      console.error(error);
    }
  };

  ////////////////////////////////////////////////////////

  const [TrayectoCalculado, setTrayectoCalculado] = useState(false);
  const [map, setMap] = useState(null);
  const [routingMachine, setRoutingMachine] = useState(null);
  const RoutingMachineRef = useRef(null);

  //calcular trayecto
  // useEffect(() => {
  //   (async () => {
  //     try {
  //       if (TrayectoCalculado === false) {
  //         if (
  //           PartidaLatitud !== "" &&
  //           PartidaLongitud !== "" &&
  //           DestinoLatitud !== "" &&
  //           DestinoLongitud !== ""
  //         ) {
  //           if (!map) return;

  //           if (map) {
  //             RoutingMachineRef.current = L.Routing.control({
  //               position: "topleft",
  //               lineOptions: {
  //                 addWaypoints: false,
  //                 draggableWaypoints: false,
  //                 styles: [
  //                   {
  //                     color: "#757de8",
  //                     weight: 4,
  //                   },
  //                 ],
  //               },
  //               language:
  //                 localStorage.getItem("Idioma") === "Español" ? "es" : "en",
  //               formatter: new L.Routing.Formatter({
  //                 language:
  //                   localStorage.getItem("Idioma") === "Español" ? "es" : "en",
  //               }),
  //               waypoints: [
  //                 [PartidaLatitud, PartidaLongitud],
  //                 [DestinoLatitud, DestinoLongitud],
  //               ],
  //               routeWhileDragging: false,
  //               extendToWaypoints: false,
  //               missingRouteTolerance: 10,
  //               collapsible: true,
  //               show: false,
  //             })
  //               .on("routesfound", function (e) {
  //                 var routes = e.routes;
  //                 var summary = routes[0].summary;
  //                 setKms((summary.totalDistance / 1000).toFixed(2));
  //                 setMin(Math.round((summary.totalTime % 3600) / 60));

  //                 setTrayectoCalculado(true);
  //               })
  //               .on("waypointschanged", function (e) {
  //                 setPartidaLatitud(e.waypoints[0].latLng.lat);
  //                 setPartidaLongitud(e.waypoints[0].latLng.lng);

  //                 setDestinoLatitud(e.waypoints[1].latLng.lat);
  //                 setDestinoLongitud(e.waypoints[1].latLng.lng);
  //               });

  //             setRoutingMachine(RoutingMachineRef.current);
  //           }

  //           if (routingMachine) {
  //             routingMachine.addTo(map);
  //             routingMachine.setWaypoints([
  //               [PartidaLatitud, PartidaLongitud],
  //               [DestinoLatitud, DestinoLongitud],
  //             ]);
  //           }
  //         }
  //       }
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   })();
  // });

  ////////////////////////////////////////////////////////

  const markerRefMarkerPartida = useRef(null);
  const eventHandlersMarkerPartida = useMemo(
    () => ({
      dragend() {
        const marker = markerRefMarkerPartida.current;
        if (marker != null) {
          setPartidaLatitud(marker.getLatLng().lat);
          setPartidaLongitud(marker.getLatLng().lng);

          calcularReverse(
            marker.getLatLng().lat,
            marker.getLatLng().lng,
            "Partida"
          );
        }
      },
    }),
    []
  );

  ////////////////////////////////////////////////////////

  const markerRefMarkerDestino = useRef(null);
  const eventHandlersMarkerDestino = useMemo(
    () => ({
      dragend() {
        const marker = markerRefMarkerDestino.current;
        if (marker != null) {
          setDestinoLatitud(marker.getLatLng().lat);
          setDestinoLongitud(marker.getLatLng().lng);

          calcularReverse(
            marker.getLatLng().lat,
            marker.getLatLng().lng,
            "Destino"
          );
        }
      },
    }),
    []
  );

  ////////////////////////////////////////////////////////

  let DireccionesAux = [];

  const [Direcciones, setDirecciones] = useState([]);

  const [BuscandoPartida, setBuscandoPartida] = useState(false);
  const [BuscandoDestino, setBuscandoDestino] = useState(false);

  //autocomplete
  const autocomplete = async (
    DireccionABuscar,
    localidad,
    provincia,
    pais,
    Numeracion,
    PartidaDestino
  ) => {
    try {
      if (DireccionABuscar !== "") {
        DireccionesAux = await apigeolocalizacion.autocomplete(
          DireccionABuscar,
          localidad,
          provincia,
          pais,
          Numeracion
        );

        setDirecciones(DireccionesAux);

        if (DireccionesAux.length > 0) {
          if (PartidaDestino === "Partida") {
            setBuscandoPartida(true);
          }
        } else {
          setBuscandoDestino(true);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  ////////////////////////////////////////////////////////

  const onChangePartidaDestino = async (e, PartidaDestino) => {
    try {
      if (e.target.value === "") {
        if (PartidaDestino === "Partida") {
          setPartidaDireccion("");
          setPartidaLatitud("");
          setPartidaLongitud("");
          setBuscandoPartida(false);
        } else {
          setDestinoDireccion("");
          setDestinoLatitud("");
          setDestinoLongitud("");
          setBuscandoDestino(false);
        }
      } else {
        setDirecciones(Direcciones.filter((a) => a.type !== Direcciones.type));

        let DireccionABuscar = e.target.value;

        //calcular Numero
        let Numeracion = "";
        let i = 0;

        let PalabrasArreglo = DireccionABuscar.split(" ");
        for (i = 0; i < PalabrasArreglo.length; i++) {
          if (isNaN(parseInt(PalabrasArreglo[i])) === false) {
            Numeracion = PalabrasArreglo[i];
          }
        }
        /////////////////

        if (DireccionABuscar.length > 4) {
          let localidad = ", " + getGeolocalizacion().split("|")[0];
          let provincia = ", " + getGeolocalizacion().split("|")[1];
          let pais = getGeolocalizacion().split("|")[2];

          // localidad = ", Ushuaia";
          // provincia = ", Tierra del Fuego Province";
          // pais = ", Argentina";

          // localidad = ", Cordoba";
          // provincia = ", Cordoba";
          // pais = ", Argentina";

          autocomplete(
            DireccionABuscar,
            localidad,
            provincia,
            pais,
            Numeracion,
            PartidaDestino
          );
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  ////////////////////////////////////////////////////////

  return (
    <div>
      <AppBar style={{ background: "#DC030E" }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            onClick={navigateToInicio}
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 0 }}>
            {nuevo_viaje}
          </Typography>
        </Toolbar>
      </AppBar>

      <div
        id="divPartidaDestino"
        style={{
          position: "absolute",
          marginTop: "-10px",
          backgroundColor: "white",
          left: "0",
          right: "0",
          margin: "15px",
          marginLeft: "55px",
          padding: "0px",
          borderRadius: "10px",
          zIndex: "30",
        }}
      >
        <Paper
          id="divPartida"
          name="divPartida"
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: "100%",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
          }}
        >
          <IconButton sx={{ p: "10px", color: "#153B5E" }}>
            <MenuIcon />
          </IconButton>
          <InputBase
            id="inputPartida"
            name="inputPartida"
            sx={{ ml: 1, flex: 1 }}
            placeholder={selecciona_punto_de_partida}
            inputProps={{ "aria-label": { selecciona_punto_de_partida } }}
            onKeyDown={(e, data) => {
              e.key === "Enter" && e.preventDefault();
            }}
            onClick={(e) => {
              setBuscandoPartida(true);
            }}
            onBlur={(e) => {}}
            onFocus={(e) => {
              e.target.select();
            }}
            onChange={(e, data) => {
              onChangePartidaDestino(e, "Partida");
            }}
          />
          <IconButton
            type="button"
            sx={{ p: "10px" }}
            onClick={(e) => {
              setPartidaDireccion("");
              setPartidaLatitud("");
              setPartidaLongitud("");
              setBuscandoPartida(false);
            }}
            style={{ color: "gainsboro" }}
          >
            <CancelIcon />
          </IconButton>
          <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
          <IconButton></IconButton>

          {BuscandoPartida ? (
            <div></div>
          ) : (
            <div>
              <IconButton
                sx={{ p: "10px" }}
                style={{
                  color: "#153B5E",
                  position: "absolute",
                  marginTop: "45px",
                }}
              >
                <MoreVertIcon />
              </IconButton>
            </div>
          )}

          {BuscandoPartida ? (
            <div></div>
          ) : (
            <IconButton
              style={{
                color: "#153B5E",
                position: "absolute",
                marginTop: "45px",
                right: "-10px",
              }}
              onClick={() => girarPartidaDestino()}
            >
              <ImportExportIcon fontSize="large" />
            </IconButton>
          )}
        </Paper>

        {BuscandoPartida ? (
          <div></div>
        ) : (
          <Paper
            id="divDestino"
            name="divDestino"
            component="form"
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: "100%",
              borderBottomLeftRadius: "10px",
              borderBottomRightRadius: "10px",
            }}
          >
            <IconButton sx={{ p: "10px", color: "#153B5E" }}>
              <MenuIcon />
            </IconButton>
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder={selecciona_punto_destino}
              inputProps={{ "aria-label": { selecciona_punto_destino } }}
              onKeyDown={(e, data) => {
                e.key === "Enter" && e.preventDefault();
              }}
              onClick={(e) => {
                setBuscandoDestino(true);
              }}
              onBlur={(e) => {}}
              onFocus={(e) => {
                e.target.select();
              }}
              onChange={(e, data) => {
                onChangePartidaDestino(e, "Destino");
              }}
            />
            <IconButton
              type="button"
              sx={{ p: "10px" }}
              onClick={(e) => {
                setDestinoDireccion("");
                setDestinoLatitud("");
                setDestinoLongitud("");
                setBuscandoDestino(false);
              }}
              style={{ color: "gainsboro" }}
            >
              <CancelIcon />
            </IconButton>
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton></IconButton>
          </Paper>
        )}

        {BuscandoPartida || BuscandoDestino ? (
          <List
            className="search-lista-resultados"
            divided
            relaxed
            style={{
              zIndex: "50",
              height: "250px",
            }}
          >
            <List.Content key="TuUbicacion">
              <List.Header style={{ paddingBottom: "8px" }}>
                <label
                  as="a"
                  onClick={() => {
                    if (BuscandoPartida) {
                      calcularLatLonGPS("Partida");
                      setBuscandoPartida(false);
                    } else {
                      calcularLatLonGPS("Destino");
                      setBuscandoDestino(false);
                    }

                    setTrayectoCalculado(false);
                  }}
                >
                  <IconButton style={{ marginTop: "-5px" }}>
                    <MyLocationIcon fontSize="small" />
                  </IconButton>
                  <b>{tu_ubicacion}</b>
                </label>
                <IconButton
                  style={{ marginTop: "-5px", right: "-130px" }}
                  onClick={() => {
                    if (BuscandoPartida) {
                      setBuscandoPartida(false);
                    } else {
                      setBuscandoDestino(false);
                    }
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </List.Header>
            </List.Content>
            {Direcciones.map((fila) => {
              return (
                <List.Content key={fila.key}>
                  <List.Header style={{ paddingBottom: "8px" }}>
                    &nbsp;&nbsp; &nbsp;&nbsp;
                    <label
                      as="a"
                      onClick={() => {
                        if (BuscandoPartida) {
                          setPartidaLatitud(fila.key.split("|")[0]);
                          setPartidaLongitud(fila.key.split("|")[1]);

                          calcularReverse(
                            fila.key.split("|")[0],
                            fila.key.split("|")[1],
                            "Partida"
                          );

                          setBuscandoPartida(false);
                        } else {
                          setDestinoLatitud(fila.key.split("|")[0]);
                          setDestinoLongitud(fila.key.split("|")[1]);

                          calcularReverse(
                            fila.key.split("|")[0],
                            fila.key.split("|")[1],
                            "Destino"
                          );

                          setBuscandoDestino(false);
                        }

                        setTrayectoCalculado(false);
                      }}
                    >
                      <b>{fila.text}</b>
                      <br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;<small>{fila.value}</small>
                    </label>
                  </List.Header>
                </List.Content>
              );
            })}
          </List>
        ) : (
          <div></div>
        )}
      </div>
      <div
        id="divResumenViaje"
        name="divResumenViaje"
        style={{
          textAlign: "center",
          position: "absolute",
          backgroundColor: "white",
          left: "0",
          right: "0",
          bottom: "0",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          paddingTop: "10px",
          zIndex: "20",
        }}
      >
        {resumen_del_viaje}
        <Divider></Divider>
        <b>PARTIDA</b>
        <br></br>
        Lat: {PartidaLatitud}
        <br></br>
        Lon: {PartidaLongitud}
        <br></br>
        Dirección: {PartidaDireccion}
        <br></br>
        <br></br>
        <b>DESTINO</b>
        <br></br>
        Lat: {DestinoLatitud}
        <br></br>
        Lon: {DestinoLongitud}
        <br></br>
        Dirección: {DestinoDireccion}
        <br></br>
        <br></br>
        Kms: {Kms}
        <br></br>
        Min: {Min}
        <br></br>
        Precio: {Precio}
      </div>

      <MapContainer
        id="Mapa"
        name="Mapa"
        className="Mapa"
        doubleClickZoom={false}
        style={{
          height: "90vh",
          marginTop: "38px",
          marginLeft: "-1px",
          marginRight: "-1px",
          marginBottom: "0px",
          zIndex: "10",
        }}
        center={position}
        zoom={11}
        scrollwheelzoom={false}
        whenCreated={(map) => setMap(map)}
      >
        <TileLayer
          attribution='&amp;copy <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <Marker
          draggable={true}
          eventHandlers={eventHandlersMarkerPartida}
          position={{
            lat: PartidaLatitud,
            lng: PartidaLongitud,
          }}
          ref={markerRefMarkerPartida}
        >
          <Popup>
            <span>
              <b>{punto_de_partida}: </b>
              <br></br> {PartidaDireccion}
            </span>
          </Popup>
        </Marker>

        <Marker
          draggable={true}
          eventHandlers={eventHandlersMarkerDestino}
          position={{
            lat: DestinoLatitud,
            lng: DestinoLongitud,
          }}
          ref={markerRefMarkerDestino}
        >
          <Popup>
            <span>
              <b>{punto_destino}: </b>
              <br></br> {DestinoDireccion}
            </span>
          </Popup>
        </Marker>
      </MapContainer>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <Player
          src={animacion}
          className="player"
          loop
          autoplay
          style={{ height: 110 }}
        />
      </Backdrop>
    </div>
  );
}
